// extracted by mini-css-extract-plugin
module.exports = {"term":"keywordTooltip_term__uViw_","tooltip":"keywordTooltip_tooltip__va_YB","arrow":"keywordTooltip_arrow__rDsoZ"};